import { Controller } from 'react-hook-form';
import { useState, useEffect } from 'react';

// Card de upload/preview de imagem reutilizável (Configurações Globais e Ajustes).
function ImageCardUpload({ campo, label, icon, iconBg, iconColor, valor, selecionado, inputRef, control, onSelect, onRemove, previewDark, colClass = 'col-md-3 mb-4' }) {
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (!selecionado && previewUrl) {
            URL.revokeObjectURL(previewUrl);
            setPreviewUrl(null);
        }
    }, [selecionado]); // eslint-disable-line react-hooks/exhaustive-deps

    const displayUrl = previewUrl || valor;
    const isPreview = !!previewUrl;

    return (
        <div className={colClass}>
            <div className="card border-0 shadow-sm h-100 ajustes-image-card" style={{ backgroundColor: '#fafbfc' }}>
                <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                        <div className={`rounded-circle ${iconBg} px-2 py-1 me-3 ajustes-icon-circle`}>
                            <i className={`bi ${icon} ${iconColor}`}></i>
                        </div>
                        <label className="form-label mb-0 fw-semibold">{label}</label>
                    </div>
                    {!displayUrl && (
                        <label
                            className={`form-control ajustes-upload-label ${selecionado ? 'border-success bg-success bg-opacity-10' : 'border-secondary'} cursor-pointer text-center py-3`}
                            onClick={() => inputRef.current?.click()}
                        >
                            <i className={`bi ${selecionado ? 'bi-check-circle-fill' : 'bi-cloud-arrow-up'} me-2`}></i>
                            <span className="fw-medium">{selecionado ? 'Arquivo selecionado' : 'Selecionar arquivo'}</span>
                        </label>
                    )}
                    <Controller
                        control={control}
                        name={campo}
                        render={({ field: { onChange, onBlur, ref } }) => (
                            <input
                                type="file"
                                style={{ display: 'none' }}
                                accept="image/*"
                                onBlur={onBlur}
                                ref={(e) => { ref(e); inputRef.current = e; }}
                                onChange={(e) => {
                                    const files = e.target.files;
                                    onChange(files);
                                    onSelect(campo, files && files.length > 0);
                                    if (previewUrl) URL.revokeObjectURL(previewUrl);
                                    setPreviewUrl(files && files.length > 0 ? URL.createObjectURL(files[0]) : null);
                                }}
                            />
                        )}
                    />
                    {displayUrl && (
                        <div className="mt-3 pt-3 border-top">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <small className={isPreview ? 'text-warning fw-semibold' : 'text-muted'}>
                                    {isPreview
                                        ? <><i className="bi bi-eye-fill me-1"></i>Prévia (não salva)</>
                                        : 'Arquivo atual:'}
                                </small>
                                <div className="d-flex gap-2">
                                    {!isPreview && (
                                        <a href={valor} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                                            <i className="bi bi-eye"></i>
                                        </a>
                                    )}
                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => inputRef.current?.click()}>
                                        <i className="bi bi-arrow-repeat"></i>
                                    </button>
                                    {!isPreview && (
                                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => onRemove(campo)}>
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className={`${previewDark ? 'bg-dark' : 'bg-white'} border rounded p-2 d-flex align-items-center justify-content-center`} style={{ height: '80px' }}>
                                <img src={displayUrl} alt={label} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ImageCardUpload;
